



























import { Component, Prop, Vue } from 'vue-property-decorator'
import { getVendor, getVendorCoverageSets } from '@/api/vendors'
import { IVendorCoverageSet } from '@/api/types-vendor'

import { TagsViewModule, ITagView } from '@/store/modules/tags-view'
import { VendorsModule } from '@/store/modules/vendors'
import { VendorCoverageSetsModule } from '@/store/modules/vendorCoverageSets'

import Sticky from '@/components/Sticky/index.vue'
import VendorCoverage from './components/VendorCoveragePage.vue'

@Component({
  name: 'VendorCoveragePage',
  components: {
    VendorCoverage,
    Sticky
  }
})
export default class extends Vue {
  @Prop({ default: false }) private isEdit!: boolean

  private validateRequire = (rule: any, value: string, callback: Function) => {
    if (value === '') {
      callback(new Error(rule.field + ' is required'))
    } else {
      callback()
    }
  }

  private coverageForm = Object.assign({}, VendorsModule.createNewItem())
  private loading = true
  private tempTagView?: ITagView

  // Coverage set List for the vendor
  private coverageSetList: IVendorCoverageSet[] = []
  private coverageSetListLoading = true
  private coverageSetListTitle = 'Loading...'
  get coverageSets(): IVendorCoverageSet[] {
    return this.coverageSetList || []
  }

  set coverageSets(list: IVendorCoverageSet[]) {
    this.coverageSetList = list
  }

  created() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id
      this.fetchData(parseInt(id))
    }
    // Why need to make a copy of this.$route here?
    // Because if you enter this page and quickly switch tag, may be in the execution of this.setTagsViewTitle function, this.$route is no longer pointing to the current page
    // https://github.com/PanJiaChen/vue-element-admin/issues/1221
    this.tempTagView = Object.assign({}, this.$route)
    console.log(`created ${this.tempTagView?.path}, ${this.tempTagView?.name}`)
  }

  private async fetchData(id: number) {
    try {
      // load the Vendor and Coverage Sets.
      this.loading = true
      const { data } = await getVendor(id)
      this.coverageForm = data
      VendorsModule.setSelectedVendor(this.coverageForm)
      const title = `${this.coverageForm.vendorId} ${this.coverageForm.lastName}, ${this.coverageForm.firstName}`
      // Set tagsview title
      this.setTagsViewTitle(title)
      // Set page title
      this.setPageTitle(title)

      this.fetchVendorCoverage(this.coverageForm.vendorId)
      this.loading = false
    } catch (err) {
      console.error(err)
    }
  }

  private async fetchVendorCoverage(id: number) {
    try {
      this.coverageSetListTitle = 'Loading, please wait...'
      this.coverageSetListLoading = true
      let list = this.coverageSets
      if (VendorCoverageSetsModule.VendorCoverageSetVendorId !== id) {
        VendorCoverageSetsModule.clearList(id)
        list = []
      }
      if (list.length === 0) {
        const response = await getVendorCoverageSets(id)
        list = response.data
        VendorCoverageSetsModule.loadList(id, list)
      }

      this.coverageSets = list
      this.coverageSetListLoading = false
      this.coverageSetListTitle = 'Vendor Coverage Sets'
    } catch (err) {
      console.error(err)
    }
  }

  private setTagsViewTitle(title: string) {
    const tagView = this.tempTagView
    console.log(`setTagsView ${title} ${tagView?.path}, ${tagView?.name}`)
    if (tagView) {
      tagView.title = title
      TagsViewModule.updateVisitedView(tagView)
    }
  }

  private setPageTitle(title: string) {
    document.title = title
  }

  private closeTagView() {
    const tagView = this.tempTagView
    if (tagView) {
      TagsViewModule.delView(tagView)
      this.toLastView(TagsViewModule.visitedViews, tagView)
    }
  }

  private toLastView(visitedViews: ITagView[], view: ITagView) {
    const latestView = visitedViews.slice(-1)[0]
    if (latestView !== undefined && latestView.fullPath !== undefined) {
      this.$router.push(latestView.fullPath).catch(err => {
        console.warn(err)
      })
    } else {
      // Default redirect to the home page if there is no tags-view, adjust it if you want
      if (view.name === 'Dashboard') {
        // to reload home page
        this.$router.replace({ path: '/redirect' + view.fullPath }).catch(err => {
          console.warn(err)
        })
      } else {
        this.$router.push('/').catch(err => {
          console.warn(err)
        })
      }
    }
  }

  private cancelClick() {
    this.closeTagView()
    return true
  }
}
